import { compareBigintSafe } from "@maven-helper/functions/Misc.function";
import { StudySiteEssential } from "@maven-rest/cdms/study/Site.dto";
import { useState } from "react";
import styled from "@emotion/styled";
import { Footer } from "@layouts/Footer";
import { HbButton } from "@maven-surface/components/base/HbButton";
import { HbParagraph } from "@maven-surface/components/base/HbParagraph";
import { COMMON_LANG } from "@maven-msg/lang/common";
import { SITE_LANG } from "@maven-msg/lang/site";
import { MvnMessage } from "@maven-msg/lib/Message";

interface PreScreeningSiteSelectionProps {
  sites: Array<StudySiteEssential>;
  onSiteSelected: (site: StudySiteEssential) => void;
}

interface StyledSiteItemProps {
  isSelected: boolean;
}

const StyledSiteSelectionWrapper = styled.div`
  margin: 1.5rem 1rem 0 1rem;
`;

const StyledSiteItemsWrapper = styled.div`
  margin-top: 1.5rem;
`;

const StyledSiteItemWrapper = styled.div`
  position: relative;
`;

const StyledSiteItem = styled.div<StyledSiteItemProps>`
  display: flex;
  align-items: center;
  margin: 0.6rem 0.4rem 0.6rem 0.4rem;
  padding: 1.4rem 0.8rem 1.4rem 0.8rem;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.03);
  font-size: 18px;
  user-select: none;

  line-height: 135%;
  cursor: pointer;

  &:hover {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.13);
  }

  &:before {
    content: "";
    width: 18px;
    min-width: 18px;
    height: 18px;
    margin-right: 0.5rem;
    border: 2px solid #718096;
    border-radius: 18px;
  }

  span {
    color: #718096;
  }

  ${({ isSelected }) =>
    isSelected &&
    `
        &:after {
          content: "";
          position: absolute;
          top: calc(1.4rem + 6px);
          left: calc(1.2rem + 5px);
          width: 12px;
          height: 12px;
          background: #259ac5;
          border-radius: 18px;
        }
    `}
`;

export function PreScreeningSiteSelection(props: PreScreeningSiteSelectionProps) {
  const { sites, onSiteSelected } = props;

  const [selectedSite, setSelectedSite] = useState<StudySiteEssential>();

  return (
    <>
      <StyledSiteSelectionWrapper>
        <HbParagraph text={MvnMessage(SITE_LANG.SITE_DROPDOWN_PLACEHOLDER)} size="3X-LARGE" bold={true} color="GRAY" />
        <StyledSiteItemsWrapper>
          {sites.map((site, idx) => (
            <StyledSiteItemWrapper key={idx}>
              <StyledSiteItem
                isSelected={compareBigintSafe(site.id, selectedSite?.id)}
                onClick={() => {
                  setSelectedSite(site);
                }}
              >
                <span>{site.name}</span>
              </StyledSiteItem>
            </StyledSiteItemWrapper>
          ))}
        </StyledSiteItemsWrapper>
      </StyledSiteSelectionWrapper>
      <Footer>
        <HbButton
          text={MvnMessage(COMMON_LANG.NEXT)}
          iconRight="ChromeBackMirrored"
          disabled={!selectedSite}
          onClick={() => selectedSite && onSiteSelected(selectedSite)}
        />
      </Footer>
    </>
  );
}
